import React, { FC, useEffect, useState } from 'react';
import { trackPromise } from 'react-promise-tracker';
import { useParams } from 'react-router-dom';
import { locales } from '../../i18n';

import PageContainer from './PageContainer';
import PageNews from './PageNews';
import PageNotFound from '../PageNotFound';

import UseNavigation from '../../uses/useNavigation';
import UsePage from '../../uses/usePage';

import { IPageDefault } from './interfaces';

// base api
const { REACT_APP_BASE_API }: any = process.env;

// page default
const PageDefault: FC<IPageDefault> = ({
  lang,
  location
}) => {
  const { lang: urlLang } = useParams<any>();
  const { getUrl, getUrlWithoutLang } = UseNavigation();
  const [ data, setData ] = useState<any>(null);
  const [ pageNotFound, setPageNotFound ] = useState<boolean>(false);

  const url: string = getUrl(urlLang, REACT_APP_BASE_API);
  const slug = location?.pathname.split(`/`);
  const slugPage = slug[slug.length - 1];

  // use effect
  useEffect(() => {
    const page = async () => await UsePage(url, true, slugPage)
      .then((response) => {
        if (!response) {
          findPageInOtherLanguages(slugPage)
        }
        else {
          setData(response)
        }
      });

    trackPromise(page());

  }, [ url, location, slugPage ]);

  const findPageInOtherLanguages = async (slug: any) => {
    for (const locale of locales) {
      if (locale !== urlLang) {
        const newUrl = getUrl(locale, REACT_APP_BASE_API);
        const foundPage = await UsePage(newUrl, true, slug);
        if (foundPage) {
          const newPath = getUrlWithoutLang(foundPage.page.meta.html_url);
          window.location.href = `/${locale}${newPath}`;
          return;
        }
      }
    }
    setPageNotFound(true);
  };

  // render
  return (
    <>
      {pageNotFound ? (
        <PageNotFound lang={lang} />
      ) : data?.page?.meta && data?.page?.meta.type === 'imprensa.Noticia' ? (
        <PageNews {...data} lang={lang} />
      ) : !data ? (
        <div />
      ) : (
        <PageContainer {...data} lang={lang} />
      )}
    </>
  );
};

export default PageDefault;